import { render, staticRenderFns } from "./CardRoomTelemedecine.vue?vue&type=template&id=de54a504&scoped=true&"
import script from "./CardRoomTelemedecine.vue?vue&type=script&lang=js&"
export * from "./CardRoomTelemedecine.vue?vue&type=script&lang=js&"
import style0 from "./CardRoomTelemedecine.vue?vue&type=style&index=0&id=de54a504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de54a504",
  null
  
)

export default component.exports